import React, { useState } from 'react';

export const AccommodationSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const accommodationFAQs = [
    {
      question: '外勞住宿費用？',
      answer: '僱主可從薪金中扣除最多10%或實際住宿費用（以較低者為準），無論外勞居住香港或內地。'
    },
    {
      question: '香港外勞住宿空間要求？',
      answer: '宿舍需為清潔獨立單位，每位外勞至少3.4平方米（約36平方呎），睡房與休息區分隔，每房最多6張床。'
    },
    {
      question: '僱主需提供哪些基本設施？',
      answer: '免費提供床鋪、床上用品、儲物空間、照明、通風及家電（如雪櫃、洗衣機），水電費由外勞自行承擔。'
    },
    {
      question: '可否安排外勞住其他地方？',
      answer: '不可，但僱主可選擇：1. 內地往返居所；2. 香港宿舍；3. 內地宿舍。'
    },
    {
      question: '可否共用房間？',
      answer: '可以，但需確保每人3.4平方米空間，擁有獨立床位及儲物區。'
    },
    {
      question: '你們可否處理住宿安排？',
      answer: '當然可以！我們擁有專業團隊，提供完整宿舍解決方案，從設計到後勤均有保障。'
    }
  ];

  const accommodationFeatures = [
    {
      icon: 'ri-home-4-line',
      title: '合規宿舍設計',
      description: '符合香港法例要求的宿舍設計方案'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全管理',
      description: '24小時保安及完善的安全管理制度'
    },
    {
      icon: 'ri-tools-line',
      title: '設施維護',
      description: '定期維護保養，確保設施正常運作'
    },
    {
      icon: 'ri-customer-service-line',
      title: '生活支援',
      description: '提供生活諮詢及緊急支援服務'
    }
  ];

  return (
    <section id="accommodation" className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            專業宿舍管理服務
          </h2>
          <p className="text-xl text-gray-600">
            涵蓋衛生、舒適及法律合規的完整解決方案
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {accommodationFeatures.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Accommodation Image */}
        <div className="mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/5ca486242994ecb41eede538246e604c.jpg"
            alt="專業宿舍環境 - 4張高碌架床"
            className="w-full h-64 md:h-96 object-cover rounded-xl shadow-lg"
          />
        </div>

        {/* FAQ Section */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            宿舍常見問題解答
          </h3>
          <div className="space-y-4">
            {accommodationFAQs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-lg">
                <button
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                  onClick={() => setActiveTab(activeTab === index ? -1 : index)}
                >
                  <span className="font-medium text-gray-900">{faq.question}</span>
                  <i className={`ri-arrow-${activeTab === index ? 'up' : 'down'}-s-line text-gray-500`}></i>
                </button>
                {activeTab === index && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
